import { useEffect, useId, type ReactNode } from "react";
import { IconX } from "@tabler/icons-react";
import { msg } from "@lingui/macro";
import { useLingui } from "@lingui/react";

import styles from "./Modal.module.css";

export interface ModalProps {
  title: ReactNode;
  onClose: () => void;
  actions: ReactNode;
  children: ReactNode;
}

export function Modal({ title, onClose, actions, children }: ModalProps): JSX.Element {
  const { i18n } = useLingui();
  const titleId = useId();

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent): void => {
      if (event.key === "Escape") {
        event.stopPropagation();
        onClose();
      }
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [onClose]);

  return (
    <div
      className={styles.scrim}
      onClick={(event) => {
        if (event.target === event.currentTarget) {
          onClose();
        }
      }}
    >
      <div className={styles.modal} role="dialog" aria-modal="true" aria-labelledby={titleId}>
        <div className={styles.head}>
          <h3 id={titleId} className={styles.title}>
            {title}
          </h3>
          <button
            type="button"
            className={styles.close}
            aria-label={i18n._(msg`Закрыть`)}
            onClick={onClose}
          >
            <IconX size={18} aria-hidden="true" />
          </button>
        </div>
        {children}
        <div className={styles.actions}>{actions}</div>
      </div>
    </div>
  );
}
